import Component from '../core/Component'
import { substitute } from '../utils/String'

export const STATES = {
    ACTIVE: 'is-active'
}

export default class SearchResult extends Component {
    constructor(element) {
        super(element)

        this.type = this.element.dataset.type

        this.ref = {
            template: null,
            title: null,
            content: null
        }

        this.timer = null
    }

    prepare() {
        this.template = this.ref.template.textContent
    }

    render(items) {
        if (!Array.isArray(items)) {
            items = []
        }

        items = items.filter(item => typeof item === 'object')

        if (items.length > 0) {
            clearTimeout(this.timer)
            this.ref.content.innerHTML = items.map(item => substitute(this.template, item)).join('')
            this.element.classList.add(STATES.ACTIVE)
        } else {
            this.element.classList.remove(STATES.ACTIVE)
            this.timer = setTimeout(() => {
                this.ref.content.innerHTML = ''
            }, 200)
        }
    }
}